// extracted by mini-css-extract-plugin
module.exports = {"button":"TextButton_button__rF46u"};